<template>
  <md-card-content>
    <div class="table-header-info">
      <div>총 {{ total }} 건</div>
      <div style="display: flex; align-content: space-between; justify-content: center;">
        <div>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon class="md-sm">get_app</md-icon>Excel 다운로드
          </md-button>
        </div>
        <select v-model="pagination.perPage" name="pages" @change="perPageChange" class="w70" style="margin-left: 5px;">
          <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
    <grid ref="cmpResultListGrid"
          :data="gridProps.data"
          :columns="gridProps.columns"
          :options="gridProps.options"
          :theme="gridProps.theme"
          :rowHeaders="gridProps.rowHeaders"
          :columnOptions="gridProps.columnOptions"
          :language="gridProps.lang"
          @click="onClickModalRow"
          @response="response"
    ></grid>
  </md-card-content>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "cmpResultListComp",
  props: {
    listType : {
      type: String,
      default : ''
    },
    totalTargetMemberCnt : {
      type: Number,
      default : 0
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data(){
    return {
      cmpResultListQuery : {
        cCmpId: ''
      },
      gridProps: {},
      pagination: {
        perPage: 50,
        page: 1,
        perPageOptions: [50, 200, 500, 1000, 5000],
        total: 0
      },
      query : {
        cCmpId : "",
        cAgentId : "",
        cCustNm : ""
      }
    }
  },

  methods: {
    sendQuery (cCmpId, cCustNm){
      let option = {
        cCmpId : cCmpId,
        cCustNm : cCustNm
      };
      this.query.cCustNm = option.cCustNm;
      this.$refs.cmpResultListGrid.invoke("readData", 1, option);
    },
    initGrid() {
      let gridColumns = [
        {header: '교우번호', name: 'cCustId', sortable: true},
        {header: '교우명', name: 'cCustNm', sortable: true},
        {header: '배정상담원', name: 'cAgentNm', sortable: true}
      ];
      if(this.listType == 'call'){
        gridColumns = [
          {header: '교우번호', name: 'cCustId', sortable: true},
          {header: '교우명', name: 'cCustNm', sortable: true},
          {header: '배정상담원', name: 'cAgentNm', sortable: true},
          {header: '통화여부', name: 'resultNm', sortable: true},
          {header: '결과', name: 'callResultNm', sortable: true},
          {header: '비고', name: 'remark'},
        ];
      };     
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_CMP_RESULT_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.cmpResultListGrid;
      this.gridProps['columns'] = gridColumns;
      this.gridProps['options'].bodyHeight = 510;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.cmpResultListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        let resultTotal = 0;
        this.pagination.total = res.data.pagination.totalCount;
        if(res.data.contents && res.data.contents.length){
          this.query.cCmpId = res.data.contents[0].cCmpId;
          res.data.contents.forEach((obj)=>{
            if(!obj.cAgentId || obj.cAgentId == ""){
              resultTotal++;
            }
          });
        }else{
          this.query.cCmpId = null;
        }

        this.$emit('update:totalTargetMemberCnt', res.data.pagination.totalCount);
        this.$emit('returnCmpResultListCnt', resultTotal);
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    /**
     * 그리드 클릭
     */
    onClickModalRow(item) {
      let _this = this;
      if(item.instance.getRow(item.rowKey) != null) {
        this.$emit('returnCmpResult', item.instance.getRow(item.rowKey));
      }
    },

    downloadExcel() {
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '캠페인 결과';
      kuaaApi.requestFileDownload(
          URL_CONST.CMP_RESULT_EXCEL_DOWNLOAD,
          this.query,
          '캠페인 결과.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    },
  }
}
</script>

<style lang="css" scoped>
</style>